export default ($axios) => ({
  fetchInvoices(payload) {
    return $axios.get('/invoices', { params: payload });
  },
});
